import { Box, CircularProgress, DialogProps } from '@mui/material';
import React from 'react';
import { SparkButton, SparkDialog } from 'sharedComponents/UI';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  confirmationMessage?: React.ReactNode;
  onPrimaryButtonClick: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  dialogStyles?: DialogProps['sx'];
  hideTitle?: boolean;
  hideSecondaryButton?: boolean;
  loading?: boolean;
};

function ConfirmationDialog({
  open,
  onClose,
  title,
  onPrimaryButtonClick,
  confirmationMessage = 'are you sure?',
  primaryButtonText = 'Yes',
  secondaryButtonText = 'No',
  dialogStyles = {},
  hideTitle = false,
  hideSecondaryButton,
  loading = false,
}: Props) {
  return (
    <SparkDialog
      open={open}
      onClose={onClose}
      title={title}
      sx={{ '& .MuiPaper-root': { minWidth: '30%' }, ...dialogStyles }}
      hideTitle={hideTitle}
    >
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        gap={2}
        padding={2}
      >
        {loading ? <CircularProgress /> : confirmationMessage}
      </Box>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        gap={2}
        padding={2}
      >
        <SparkButton
          onClick={onPrimaryButtonClick}
          variant='contained'
          sx={{ padding: 2 }}
          disabled={loading}
        >
          {primaryButtonText}
        </SparkButton>
        {!hideSecondaryButton && (
          <SparkButton
            onClick={onClose}
            variant='outlined'
            sx={{ padding: 2 }}
            disabled={loading}
          >
            {secondaryButtonText}
          </SparkButton>
        )}
      </Box>
    </SparkDialog>
  );
}

export default ConfirmationDialog;
